module.exports = __webpack_public_path__ + "img/rank5.e2fb91d4.png";